'use client';

import { Lead } from '@hc-frontend/core-types';
import { createContext, useContext, useMemo } from 'react';

import { LeadProviderProps } from './use-lead.types';

const ApplicantLeadContext = createContext<Lead | undefined>(undefined);

export const useApplicantLead = () => useContext(ApplicantLeadContext);

export function ApplicantLeadProvider({ children, lead }: LeadProviderProps) {
  const value = useMemo(() => lead, [lead]);

  return (
    <ApplicantLeadContext.Provider value={value}>
      {children}
    </ApplicantLeadContext.Provider>
  );
}
